export enum ROSTERSTREAM_MESSAGES {
  AUTH_ERROR_GENERIC = 'There was an issue login. Please try again. If the issue persists, contact support.',
}
